export const NOTIFICATION_MESSAGE = {
	NAME_ERROR_PATTERN_MESSAGE: 'Only characters, digits, dot(.), hyphen(-), space and underscore(_) are allowed in name',
	ERROR_500: 'Failed to <do something> (error: 500). Please try again later.',
	SYSTEM_DOWN_ERROR: 'The service you requested is temporary unavailable, please try again later!',
	DOWNLOAD_REPORT_SUCCESS: 'Downloaded report(s) successfully',
};
